<template>
  <div>
      <div class="waf-component waf-error-page">
        <div class="container">
            <div class="error-wrapper">
                <div class="error-inn-wrapper">
                    <div class="error-msg-wrap">
                        <div class="error-no">
                            <h3 class="title">
                                <span>4</span>
                                <span class="cham-img">
                                    <img src="/static-assets/images/cssimages/error-cham.svg" alt="">
                                </span>
                                <span>4</span>
                            </h3>
                        </div>
                        <div class="error-msg">
                            <p class="txt1">Sorry, page not found</p>
                            <p class="txt2"> The page you are looking for may have been
                                moved, updated or deleted. </p>
                            <a class="btn" href="/">back to home</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import { cssImport } from "../../assets/js/common";

export default {

  mounted() {
    cssImport(["/static-assets/css/error.css"]);
  },
};
</script>

